import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'locale'
})
export class LocalePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var d = new Date(value);

    return d.toLocaleString();
  }

}
